import { Component } from '@angular/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { ContainerTypeService } from '../../core/services/container-type.service';
import { HttpClientModule, HttpErrorResponse } from '@angular/common/http';
import { CommonModule, NgIf } from '@angular/common';
import { ContainerTypeFormBaseComponent } from '../container-type-form-base.component';
import { ContainerType } from '../../core/models/container-type.model';

@Component({
  selector: 'app-container-type-create',
  templateUrl: './container-type-create.component.html',
  styleUrls: ['./container-type-create.component.scss'],
  standalone: true,
  imports: [ReactiveFormsModule, RouterModule, HttpClientModule, CommonModule],
})
export class ContainerTypeCreateComponent extends ContainerTypeFormBaseComponent {
  constructor(
    protected override fb: FormBuilder,
    private containerTypeService: ContainerTypeService,
    private router: Router,
  ) {
    super(fb);
  }

  onSubmit(): void {
    if (this.containerTypeForm.valid) {
      const newContainerType: ContainerType = this.containerTypeForm.value;
      this.containerTypeService.createContainerType(newContainerType).subscribe({
        next: response => {
          console.log('Tipo de contenedor creado:', response);
          this.router.navigate(['/container-types']);
        },
        error: (error: HttpErrorResponse) => {
          console.error('Error al crear el tipo de contenedor:', error.message);
          this.errorMessage = error.error || 'Ocurrió un error al crear el tipo de contenedor';
        },
        complete: () => {
          console.log('Solicitud de creación de tipo de contenedor completada');
        },
      });
    } else {
      this.markAllFieldsAsTouched();
    }
  }
}
